// The word cloud's own export, split by what the payload is. A CSV is the drawn word list, which
// the cloud already holds, so it is built and downloaded here. An image is a serialization of the
// rendered svg, which only the shell can reach, so that branch falls through to it.

import { contentToCSV } from '@aytm/app/stats/lib/render/svg-export'
import { questionPositionToId } from '@aytm/app/stats/page/components/lib/utils'

// A key addresses the question first and its sub-items after, separated either way; the file is
// named for the question, with the sub-item trail appended.
const calcFileName = questionKey => {
  const parts = String(questionKey).split(/[._]/)
  const base = questionPositionToId(parts[0]).toLowerCase()

  return 1 < parts.length ? `${base}-${parts.slice(1).join('-')}` : base
}

// A merged cloud counts every occurrence of a word, an unmerged one the responses it appears in.
const calcFrequencyCell = mergeWords => (1 === mergeWords ? 'times' : 'f')

export const buildOnWcExport = ({ questionKey, mergeWords, onExport }) => {
  return (params, data, callback) => {
    if ('csv' !== params?.fileType) return onExport?.(params, data, callback)

    const cell = calcFrequencyCell(mergeWords)
    const rows = (data || []).map(word => `${word.text},${word[cell]}`)

    contentToCSV(['Word,Frequency', ...rows].join('\r\n'), `${calcFileName(questionKey)}-word_cloud`, callback)
  }
}
